import { useMemo } from 'react';

import type { IFuseOptions } from 'fuse.js';

import type { CatalogItem } from '@/entities/catalog-item';

import { createCatalogFuse } from '../lib/catalogFuse';
import { matchCatalogCodes } from '../lib/gxCodeMatch';

export function useFuzzySearchedCatalogData(
  items: CatalogItem[],
  search: string | null,
  options?: IFuseOptions<CatalogItem>
): CatalogItem[] {
  const fuse = useMemo(() => createCatalogFuse(items, options), [items, options]);

  return useMemo(() => {
    const query = search?.trim();
    if (!query) return items;

    // Permanent: a code query is a Code lookup, never fuzzy.
    const codeMatches = matchCatalogCodes(items, query);
    if (codeMatches !== null) return codeMatches;

    return fuse.search(query).map(result => result.item);
  }, [fuse, items, search]);
}
